import objectFitImages from 'object-fit-images';
import elementClosest from 'element-closest';
import 'nodelist-foreach-polyfill';

export default (function(){
	elementClosest(window);
	objectFitImages();
})();
